@if (addedTemplateRecipients > 0) {
  <div
    class="selection-section">
    <div>
      <div
        class="selected-recipients"
        fxLayout="row"
        fxLayoutAlign="start-between center">
        <div>{{ 'COMMUNICATIONS.TEMPLATE-RECIPIENTS' | translate }}</div>
        <div class="total-counter">
          {{ addedTemplateRecipients }}
        </div>
      </div>
      @if (templateDistRecipients?.length) {
        <div
          (click)="onDistDetails()"
          class="recipient-section"
          fxLayout="row"
          fxLayoutAlign="space-between center">
          <div
            fxLayout="row"
            fxLayoutAlign="start center">
            <img src="assets/images/purple_distro-group.svg" />
            {{ 'COMMUNICATIONS.RECIPIENT-TYPE-DIST-LIST' | translate }}
            <span class="counter">({{ templateDistRecipients?.length }})</span>
            <span class="counter">({{ 'COMMUNICATIONS.TOTAL-CONTACTS' | translate : { number: totalDistListContacts } }})</span>
          </div>
        </div>
      }
      @if (templateUserRecipients?.length) {
        <div
          (click)="onUserDetails()"
          class="recipient-section"
          fxLayout="row"
          fxLayoutAlign="space-between center">
          <div
            fxLayout="row"
            fxLayoutAlign="start center">
            <img src="assets/images/purple_account-profile.svg" />
            {{ 'COMMUNICATIONS.RECIPIENT-TYPE-USERS' | translate }}
            <span class="counter">({{ templateUserRecipients?.length }})</span>
          </div>
        </div>
      }
      @if (templateGroupRecipients?.length) {
        <div
          class="recipient-section"
          fxLayout="row"
          fxLayoutAlign="space-between center">
          <div
            fxLayout="row"
            fxLayoutAlign="start center">
            <img src="assets/images/people-group.svg" />
            {{ 'COMMUNICATIONS.RECIPIENT-TYPE-GROUPS' | translate }}
            <span class="counter">({{ templateGroupRecipients?.length }})</span>
          </div>
        </div>
      }
      @for (datasetInfo of templateDatasetsSelected; track datasetInfo.uId) {
        <div>
          @if (datasetInfo?.documentCount) {
            <div
              (click)="onDatasetDetails(datasetInfo.uId)"
              [title]="datasetInfo?.filterDisplay || ''"
              class="recipient-section"
              fxLayout="row"
              fxLayoutAlign="space-between center">
              <div
                fxLayout="row"
                fxLayoutAlign="start center">
                <img
                  class="dataset"
                  [src]="datasetInfo.datasetIcon" />
                {{ datasetInfo.datasetName }}
                <span class="counter">({{ datasetInfo?.documentCount }})</span>
                <span class="counter">({{ 'COMMUNICATIONS.TOTAL-CONTACTS' | translate : { number: datasetInfo.contactCount } }})</span>
              </div>
            </div>
          }
        </div>
      }
    </div>
  </div>
}

<topo-comms-recipient-list-select
  #listSelect
  [getSelectedUIds]="getSelectedUIds"
  [isDuplicateFilter]="false"
  [intitalSelectedTypeUId]="selectedRecipientTypeUId"
  [recipientFilters]="[recipientFilter]"
  [isActive]="recipientsSelectionActive"
  [includeUsers]="true"
  [includeGroups]="false"
  [includeDistro]="true"
  [includeDatasets]="true"
  [readonlyTemplateRecipients]="true"
(recipientsClosed)="recipientsClosed()"></topo-comms-recipient-list-select>
